// src/store/features/ui/uiSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { UIState } from "./types";
import { UserRole } from "../../client";

const initialState: UIState = {
  isMenuOpen: false,
  sidebarScrollPosition: 0,
  originalRole: null,
  currentRole: null,
};

const persistConfig = {
  key: "ui",
  storage,
  // 永続化したい項目のみを指定
  whitelist: ["originalRole", "currentRole"],
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setMenuOpen: (state, action: PayloadAction<boolean>) => {
      state.isMenuOpen = action.payload;
    },
    setSidebarScrollPosition: (state, action: PayloadAction<number>) => {
      state.sidebarScrollPosition = action.payload;
    },
    setOriginalRole: (state, action: PayloadAction<UserRole | null>) => {
      state.originalRole = action.payload;
    },
    setCurrentRole: (state, action: PayloadAction<UserRole | null>) => {
      state.currentRole = action.payload;
    },
  },
});

export const {
  setMenuOpen,
  setSidebarScrollPosition,
  setOriginalRole,
  setCurrentRole,
} = uiSlice.actions;

export default persistReducer(persistConfig, uiSlice.reducer);
